import { useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);

 const onSubmit = async (event: React.SyntheticEvent<HTMLFormElement>) => {
debugger;
  event.preventDefault();

  setError("");

  setLoading(true);

  try {

    await login(
      email,
      password
    );

    const auth =
      JSON.parse(
        localStorage.getItem(
          "nsj_session"
        ) || "{}"
      );

    if (
      auth.role === "Admin"
    ) {

      navigate(
        "/admin/dashboard",
        {
          replace: true,
        }
      );
    }
    else {

      navigate(
        "/",
        {
          replace: true,
        }
      );
    }

  } catch (err) {

    setError(
      err instanceof Error
        ? err.message
        : "Login failed"
    );

  } finally {

    setLoading(false);
  }
};

  return (
    <div className="ns-login-bg">
      <div className="ns-login-card">
        <div className="ns-login-logo">💎</div>
        <h1 className="ns-login-title-lg">Welcome back</h1>
        <p className="ns-login-subtitle-lg">Sign in to NineSistersJewels admin panel</p>

        {error && (
          <div className="ns-alert-error">
            <i className="bi bi-exclamation-circle"></i> {error}
          </div>
        )}

        <form onSubmit={onSubmit} className="ns-form-col">
          <div>
            <label className="ns-label">Email Address</label>
            <div className="ns-input-icon-wrap">
              <i className="bi bi-envelope ns-input-icon"></i>
              <input
                className="ns-input ns-input-pl"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="admin@example.com"
                required
              />
            </div>
          </div>

          <div>
            <label className="ns-label">Password</label>
            <div className="ns-input-icon-wrap">
              <i className="bi bi-lock ns-input-icon"></i>
              <input
                className="ns-input ns-input-plr"
                type={showPw ? "text" : "password"}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPw(s => !s)}
                className="ns-input-icon-right"
              >
                <i className={`bi bi-eye${showPw ? "-slash" : ""}`}></i>
              </button>
            </div>
          </div>

          <button
            type="submit"
            className="btn-theme ns-btn-full-lg"
            disabled={loading}
          >
            {loading
              ? <><i className="bi bi-arrow-repeat ns-spin"></i> Signing in...</>
              : <><i className="bi bi-box-arrow-in-right"></i> Sign In</>
            }
          </button>
        </form>

        <div className="ns-login-links">
          <Link to="/admin/register" className="ns-login-link-primary">
            Create account
          </Link>
          <Link to="/admin/reset-password" className="ns-login-link-secondary">
            Forgot password?
          </Link>
        </div>
      </div>
    </div>
  );
}
